var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillsInitialsA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 24,
    rx: 12,
    fill: "#91950F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4985 18.4001C9.55185 18.4001 7.16663 16.0654 7.16663 13.1877H17.8333C17.8303 16.0654 15.4451 18.4001 12.4985 18.4001Z",
    fill: "#FEFDFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4985 13.1878C10.0895 13.1878 8.13794 11.28 8.13794 8.92505H16.862C16.859 11.2771 14.9075 13.1878 12.4985 13.1878Z",
    fill: "#FEFDFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4985 8.92206C10.6212 8.92206 9.10034 7.43531 9.10034 5.6001H15.8996C15.8966 7.43531 14.3758 8.92206 12.4985 8.92206Z",
    fill: "#FEFDFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8282 16H20.4305L23.5711 7.27273H25.0924L28.2331 16H26.8353L24.368 8.85795H24.2998L21.8282 16ZM22.0626 12.5824H26.5967V13.6903H22.0626V12.5824Z",
    fill: "#FEFDFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsInitialsA);
export default __webpack_public_path__ + "static/media/Skills Initials A.85abed20b7b2c0e692d089fd98b9fa23.svg";
export { ForwardRef as ReactComponent };